$(document).ready(() => {
    $('.svg-path-link a').hover(
        function() {
            // Find the closest circle-item
            const circleItem = $(this).closest('.circle-item');

            // Remove 'active-circle' class from all circle items
            $('.circle-item').removeClass('active-circle');

            // Remove 'active-circle' class from parent
            const parent = circleItem.closest('.values-circle');
            parent.removeClass('active-circle');

            // Add 'active-circle' class to the hovered circle item
            circleItem.addClass('active-circle');

            // Add 'active-circle' class to the parent
            parent.addClass('active-circle');
        },
        function() {
            // Find the closest circle-item
            const circleItem = $(this).closest('.circle-item');

            // Optionally remove the active-circle class on mouse leave
            circleItem.removeClass('active-circle');

            // Check if any other circle item is active-circle
            const anyActive = $('.circle-item.active-circle').length > 0;

            // If no circle item is active-circle, remove the active-circle class from the parent
            const parent = circleItem.closest('.values-circle');
            if (!anyActive) {
                parent.removeClass('active-circle');
            }
        }
    );
});